//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import action from './action';
import { yoButton } from 'components';

export default {
  name: 'index',
  props: ['params'],
  metaInfo: {
    title: ''
  },
  created: async function () {
  },
  data() {
    return {};
  },
  computed: {},
  components: {
    yoButton
  },
  methods: {
    ...action,
    success() {
      this.$router.push({
        path: '/yeepay/success'
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/debug/page.vue